import { PlatformLocation } from '@angular/common'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
  selector: 'dmmp-content-table',
  templateUrl: './content-table.component.html'
})
export class ContentTableComponent implements OnInit {

  @Input() module
  @Input() identifier
  @Input() defaultClass = 'content-table'
  @Output() page = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  constructor(
    private location: PlatformLocation
  ) { }

  ngOnInit(): void {

    this.selectByCurrentRoute()
    this.closeCollapse(null)

    if (this.module?.content?.table_content) {
      if (this.module?.content?.table_content?.length > 0) {
        if (this.module?.content?.table_content[0]?.children?.length > 0) {
          this.module.content.table_content[0].data.isCollapse = false
        }
      }
    }
  }

  closeCollapse(currentCollapseColumn) {
    if (this.module?.content?.table_content) {
      this.module.content.table_content.forEach(
        (columnItem) => {
          if (columnItem.data !== currentCollapseColumn) {
            columnItem.data.isCollapse = true
          }
        }
      )
    }
  }

  removeActive(currentActiveLink) {
    if (this.module?.content?.table_content) {
      this.module.content.table_content.forEach(
        (columnItem) => {

          if (columnItem.data !== currentActiveLink) {
            columnItem.data.isActive = false
          }

          if (columnItem.children) {
            columnItem.children.forEach(linkItem => {
              if (currentActiveLink !== linkItem.data) {
                linkItem.data.isActive = false
              }
            })
          }
        }
      )
    }
  }

  selectByCurrentRoute() {
    this.module?.content?.table_content.forEach(
      (columnItem) => {
        if ((columnItem.data.link === this.location.pathname) || (columnItem.data.path === this.location.pathname)) {
          columnItem.data.isActive = true
        }
        if (columnItem.children) {
          columnItem.children.forEach(linkItem => {
            if ((linkItem.data.link === this.location.pathname) || (linkItem.data.path === this.location.pathname)) {
              linkItem.data.isActive = true
            }
          })
        }
      }
    )
  }

}
